import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import SvgImage from "../../../Icons/Icons";
import {
  cleanFleet,
  getFleetTracker,
} from "../../../../services/Store/Actions/driverslistActions";
import moment from "moment";
import ClipLoader from "react-spinners/ClipLoader";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import SpeedIcon from "@mui/icons-material/Speed";
import { cleanGetGpsComputedData, getGpsComputedDataAction } from "../../../../services/Store/Actions/fleetActions";

function ManageVehicleDetailsCard(props) {
  const {
    color,
    setColor,
    activeStatus,
    assignedStatus,
    allVehicle,
    addNext10Data,
    addPrevious10Data,
    startIndex,
    setOpenStatus,
    openStatus,
  } = props;
  const dispatch = useDispatch();
  const [fetchMoreData, setFetchMoreData] = useState(true);
  //const [offset, setOffset] = useState(0);
  const [serialNum, setSerialNum] = useState(0);
  const [displayName, setDisplayName] = useState([]);
  const [mapView, setMapView] = useState("-1");
  const ref = useRef(null);
  const { allFleetTrackerList, loader, allFleetTracker } = useSelector(
    (state) => state?.driverlist
  );
  const { gpsStatus, gpsData } = useSelector((state) => state?.fleet);
  const [from, setFrom] = useState("");

  console.log("ghjklkjhgbhnjmk", allVehicle);

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  // const [loader, setLoader] = useState("");
  const [bank, setBank] = useState("YesBank");
  const [reissueData, setReissueData] = useState();

  // to handle success or failure of re-issue. If failed, then state=1, and chasis option available
  const [reIssue, setReIssue] = useState(0);

  function handleShow() {
    setOpen(true);
  }
  const handleLocation = (index) => {
    if (mapView == "-1") setMapView(index);
    else setMapView("-1");
  };

  const handleCloseOpenLink = () => {
    setDisplayName(displayName.filter((e) => e.name === ""));
    props.setOpenLink(false);
  };
  const handletoggleOpenLink = () => {
    setDisplayName(displayName.filter((e) => e.name === ""));
    props.setOpenLink(!props.openLink);
  };
  const handlenShowOpenLink = (id, cat, regNo) => {
    props.setRegNumber(regNo);
    props.setFleetId(id);
    props.setVehCat(cat);
    props.setOpenLink(true);
  };

  const isReissueAvailable = useSelector(
    (state) => state?.fastag?.isReissueAvailable
  );
  const hotlistStatus = isReissueAvailable?.npciStatus;
  const reissueStatus = isReissueAvailable?.status;

  console.log("iiiiiiiiiiiiiiii", isReissueAvailable);
  // function handleClick(Id, i) {
  //   // window.location=`/Vehicles?u=${id}&r=${regNo}&v=${cat}`
  //   console.log("Yaha toh hoga hi bhaiii", window.location.href);
  //   console.log("id@@@", Id);
  //   navigate(`/VehiclesV2/${Id.fleetId}`);
  //   //window.location.href=Id.fleetId
  //   // setColor(i);
  // }

  const handleClick = (e, i) => {
    console.log("hhjjjjjj", props,e);
    props.allowTrigger();
    // props?.setSelection("1");
    props.setVehRank(props.offset + i + 1);
    props.setRegNumber(e.vrn);
    console.log(
      "drivers ki list",
      `/VehiclesV2/${e.vrn}?search=${props.search}&offset=${props.offset}`
    );

    navigate(`/GPS/${e.vrn}?search=${props.search}&offset=${props.offset}`, {
      state: { vehicle: e },
    });
    props.setIsGPSCard(0);
    setColor(i);
  };

  let { id } = useParams();

  useEffect(() => {
    console.log("mkjoijiojsdfsdfre",props?.selection);
      if(props?.selection == "1" || props?.selection == "2"){
        dispatch(cleanGetGpsComputedData());
        dispatch(
          getGpsComputedDataAction({ vrn: id }, (res) => {
            console.log("mkjoijiojfre", res);
          })
        );
      }
      else if(props?.selection == "3"){
        dispatch(cleanGetGpsComputedData());
        dispatch(
          getGpsComputedDataAction({ vrn: id,from : from}, (res) => {
            console.log("mkjoijiojfre", res);
          })
        );
      }
  },[id,openStatus])
  //console.log("ppp",id)

  // useEffect(() => {
  //   //console.log("Yaha toh hoga hi bhaiii", window.location.href);
  //   let urlId = window.location.pathname.split("/");
  //   //console.log("peterrr",urlId)
  //   if (urlId.length === 3) {
  //     if (urlId[2] != undefined && urlId[2] != "") {
  //       let i = advancedVehicleList?.findIndex(
  //         (element) => element.fleetId === urlId[2]
  //       );
  //       //handleUserId(urlId[2]);
  //       //console.log("han ji",i)
  //       setColor(i);
  //       if (id) {
  //         if (props.regNumber) {
  //           dispatch(
  //             reissueAvailableAction({
  //               fleetId: id,
  //               vrn: props.regNumber,
  //             })
  //           );
  //         }
  //       }
  //     }
  //   }
  // }, [id, advancedVehicleList]);

  useEffect(() => {
    //console.log("Yaha toh hoga hi bhaiii", window.location.href);
    let urlId = window.location.pathname.split("/");
    console.log("peterrr",urlId,id)
    if (urlId.length === 3) {
      if (urlId[2] != undefined && urlId[2] != "") {
        let i = allVehicle?.findIndex(
          (element) => element?.vrn == urlId[2]
        );
        let item = allVehicle?.find(
          (element) => element?.vrn == urlId[2]
        );
        //handleUserId(urlId[2]);
        console.log("han ji",item,allVehicle)
        if(item) handleClick(item,0)
        setColor(i);
      }
    }
  }, [id, allVehicle]);

  console.log("offsettinggggggggggg", props.offset);

  const handlePrevButton = () => {
    //props.nextTrigger();
    if (props.offset > 0) {
      props.nextTrigger();
      props.setOffset(props.offset - 7);
      //setSerialNum(serialNum - 15);
      //console.log("offset", offset);
      // dispatch(
      //   getVehicleListAction({
      //     offset: props.offset - 15,
      //     limit: 15,
      //     search: props.search,
      //     minKyc: "",
      //     sortAs: "",
      //     sortBy: "",
      //   })
      // );
      dispatch(cleanFleet());
      dispatch(
        getFleetTracker({
          offset: props.offset - 7,
          limit: 7,
          search: "",
          minKyc: "",
          sortAs: "",
          sortBy: "",
        })
      );
    }
    console.log("X--");
  };

  const handleNextButton = () => {
    if (allFleetTracker?.count - props.offset > 7) {
      props.nextTrigger();
      props.setOffset(props.offset + 7);
      //setSerialNum(serialNum + 15);
      //console.log("offset", offset);
      // dispatch(
      //   getVehicleListAction({
      //     offset: props.offset + 15,
      //     limit: 15,
      //     search: props.search,
      //     minKyc: "",
      //     sortAs: "",
      //     sortBy: "",
      //   })
      // );
      dispatch(cleanFleet());
      dispatch(
        getFleetTracker({
          offset: props.offset + 7,
          limit: 7,
          search: "",
          minKyc: "",
          sortAs: "",
          sortBy: "",
        })
      );
    }
    console.log("X++");
  };

  // for handling otp modal

  const [openOTP, setOpenOTP] = useState(false);
  const handleCloseOTP = () => {
    setOpenOTP(false);
    //setProceed(0);
    //console.log("closed");
  };

  const toggleModalOTP = () => {
    setOpenOTP(!openOTP);
    //setProceed(0);
  };

  const handleShowOTP = () => {
    handletoggleOpenLink();
    setOpenOTP(true);
  };

  // for handling KYC` modal

  const [openKYC, setOpenKYC] = useState(false);
  const handleCloseKYC = () => {
    setOpenKYC(false);
    //setProceed(0);
    //console.log("closed");
  };

  const toggleModalKYC = () => {
    setOpenKYC(!openKYC);
    //setProceed(0);
  };

  const handleShowKYC = () => {
    toggleModalOTP();
    setOpenKYC(true);
  };

  // for handling fastag issue modal

  const [openIssue, setOpenIssue] = useState(false);
  const handleCloseIssue = () => {
    setOpenIssue(false);
    //setProceed(0);
    //console.log("closed");
  };

  const toggleModalIssue = () => {
    setOpenIssue(!openIssue);
    //setProceed(0);
  };

  const handleShowIssue = (kycStatus) => {
    if (kycStatus === "kyc done") {
      handletoggleOpenLink();
    } else {
      toggleModalKYC();
    }
    setOpenIssue(true);
  };

  // for handling reissue otp modal

  const [openReissue, setOpenReissue] = useState(false);
  const handleCloseReissue = () => {
    setOpenReissue(false);
    //setProceed(0);
    //console.log("closed");
  };

  const toggleModalReissue = () => {
    setOpenReissue(!openReissue);
    //setProceed(0);
  };

  const handleShowReissue = () => {
    toggleModalIssue();
    setOpenReissue(true);
  };

  return (
    <div className="main-all-customer-list row">
      <div id="scrollableDivCustomer col-12" className="">
        {loader ? (
          <div>
            <div
              className="text-center"
              style={{
                padding: 16,
              }}
            >
              <ClipLoader
                color={"#2E7C7B"}
                loading={true}
                size={40}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          </div>
        ) : (
          <>
            {allVehicle?.map((d, i) => {
              const regName =
                d?.driverName === undefined || d?.driverName === null
                  ? "No Driver"
                  : d?.driverName;
              console.log(";;;;;;;;;;;;;;;;;;;;;;", d);

              const firstName_initials = regName[0];
              // const lastName_initials = d.lastName[0] + ".";
              let dd = d?.lastTripJson
                ? moment
                    .duration(
                      moment(d?.lastUpdated, "YYYY-MM-DD HH:mm:ss").diff(
                        moment(d?.lastTripJson?.fromTime)
                      )
                    )
                    
                : moment.duration(
                    moment(new Date()).diff(
                      moment(d?.lastUpdated, "YYYY-MM-DD HH:mm:ss")
                    )
                  );

                  console.log("nsiheufh", i,d, moment(d?.lastUpdated, "YYYY-MM-DD HH:mm:ss").diff(
                    moment(d?.lastTripJson?.fromTime)
                  ));

              let s = dd?.days() ? (dd?.days() ? dd?.days()+"d " : "") :
                      (dd?.hours() ? (dd?.hours()+"h ") : "") +
                      (dd?.minutes() ? (dd?.minutes ()+"m ") : ""); 
              // let s = "4h 56m";
              let end = null,endColor=null;

              if(d?.currentTripEndTime){
                if(moment(d?.currentTripEndTime).diff(
                  moment(new Date(), "YYYY-MM-DD HH:mm:ss")
                )<0){
                  end = moment.duration(
                    moment(new Date(), "YYYY-MM-DD HH:mm:ss").diff(
                      moment(d?.currentTripEndTime)
                    ))
                  endColor = true;
                }
                else {
                  endColor = false;
                  end = moment.duration(
                  moment(d?.currentTripEndTime).diff(
                    moment(new Date(), "YYYY-MM-DD HH:mm:ss")
                  ))
                }
              }
              let endData = end ? (end?.days() ? end?.days()+"d " : "") +
              (end?.hours() ? (end?.hours()+"h ") : "") +
              (end?.minutes() ? (end?.minutes ()+"m ") : "") : null
              console.log("jniojheiroj",d?.currentTripEndTime,endColor)
              return (
                <div
                  className={
                    color === i
                      ? "div-table-row-gps actve-button-chosen-for-vehicle"
                      : "div-table-row-gps"
                  }
                  style={{
                    border: "0.5px solid #E2E2E2",
                    borderRadius: "0.5rem",
                    margin: "0px 8px 8px",
                    boxShadow: " 0px 4px 20px 0px #25252d1a !important",
                    cursor: "pointer",
                  }}
                  onClick={() => handleClick(d, i)}
                  key={i}
                >
                  <div className="row">
                    <div class=" rowContN col-12 FontNBList row">
                      {/* <div data-letters={firstName_initials.toUpperCase()}> */}
                      <div
                        data-letters-vehicle={startIndex + i + 1}
                        style={{ paddingTop: "5px", width: "50px" }}
                        className="col-2"
                      ></div>
                      {/* <div
                        className="col-2 FontNB20 VehicleShortName"
                        style={{ width: "65px" }}
                      >
                        {d?.vrn.substr(d?.regNumber?.length - 4)}
                      </div> */}
                      <div className="col-6 FontNB20 VehicleShortName">
                        <span className="">
                          {d?.vrn?.length > 10
                            ? d?.vrn.substring(0, 8) + ".."
                            : d?.vrn}
                        </span>
                        {/* <p className="FontNBList"> {regName}</p> */}
                        {/* <div class=" FontSmall">{regName}</div> */}
                      </div>
                    </div>
                    <div
                      className="d-flex Driver-gps"
                      style={{ color: "#9d9494" }}
                    >
                      <div
                        className=""
                        style={{  padding: "0 0 0 36px" }}
                      >
                        Driver: {regName}
                      </div>
                    </div>
                    <div className="d-flex FontNR14">
                      <div
                        // className="col-1"
                        style={{ textAlign: "center" }}
                      >
                        <SvgImage name="speed" />
                      </div>

                      <div
                        // className={s?.length > 8 ? "col-3" : "col-2"}
                        style={{ padding: "0px 14px 0 14px",borderRight : "1px solid",borderColor : "black",color : d?.status == "STOPPED" ? "rgb(235 135 4)" : "#59f03b" }}
                      >
                        {s}
                      </div>

                      <div style={{ borderRight : "1px solid", padding: "0 7px" }} >
                        {d?.lastTripJson ? (
                          (parseFloat(d?.odometer) -
                            parseFloat(d?.lastTripJson?.fromOdometer))?.toFixed() || 0
                        ) : (
                          parseFloat(d?.odometer)?.toFixed()
                        )}
                      </div>

                      <div
                        // className="col-5"
                        style={{ padding: "0 7px" }}
                      >
                        Speed: {d?.speed} Km/h
                      </div>
                    </div>
                    <div className="d-flex FontNR14">
                      <div className="" style={{}}>
                        <LocalGasStationIcon style={{ color: "#ed752e",width:"20px", height : "20px" }} />
                      </div>
                      <div
                        className=""
                        style={{padding: "0px 14px 0 14px"}}
                      >
                        Fuel: {d?.fuelLeft}
                      </div>
                    </div>

                    <div className="d-flex FontNR14">
                      <div className="" style={{}}>
                        <SpeedIcon style={{ color: "black",width:"20px", height : "20px" }} />
                      </div>
                      <div
                        className=""
                        style={{ padding: "0px 14px 0 14px" }}
                      >
                        Odometer: {parseFloat(d?.odometer)?.toFixed()}
                      </div>
                    </div>
                    {d?.location ? (
                      <>
                        <div className="d-flex FontNR14">
                          <div className="" style={{  }}>
                            <SvgImage name="locationPin" width="18" height = "18" />
                          </div>
                          <div className="" style={{padding: "0px 0px 0 14px",wordBreak:"break-all" }}>
                            {d?.location}
                          </div>
                        </div>{" "}
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="d-flex FontNR14">
                      <div className="" style={{}}>
                        <SvgImage name="routes"/>
                      </div>
                      <div className="" style={{ padding: "0px 0px 0 14px" }}>
                        Trip : {d?.currentTripNo || " N/A"} |
                        {d?.currentTripNo
                          ? ` ${d?.currentTripLocation}`
                          : " N/A"}
                      </div>
                    </div>
                    {
                      d?.currentTripNo && d?.currentTripStartTime ?                     
                      <div className="d-flex FontNR14">
                      <div className="" style={{ }}>
                        <SvgImage name="routes" />
                      </div>
                      <div className="" style={{  padding: "0px 0px 0 14px"  }}>
                        Start At : <span>&nbsp;</span>
                      </div>
                      <div style={{  color : endColor? "red" : "green"  }}>
                      {d?.currentTripStartTime || " N/A"}
                      </div>
                    </div> : <></>
                    }
                    {
                      d?.currentTripNo && d?.currentTripEndTime ?                     
                      <div className="d-flex FontNR14">
                      <div className="" style={{ }}>
                        <SvgImage name="routes" />
                      </div>
                      <div className="" style={{  padding: "0px 0px 0 14px"  }}>
                        End At : <span>&nbsp;</span>
                      </div>
                      <div style={{  color : endColor? "red" : "green"  }}>
                      {d?.currentTripEndTime || " N/A"}
                      </div>
                    </div> : <></>
                    }
                    {
                      d?.currentTripNo && endData ?  <div className="d-flex FontNR14">
                      <div className="" style={{ }}>
                        <SvgImage name="routes" />
                      </div>
                      <div className="" style={{  padding: "0px 0px 0 14px"  }}>
                        ETA : <span>&nbsp;</span>
                      </div>
                      <div style={{  color : endColor? "red" : "green"  }}>
                      {endData
                          ? endData
                          : " N/A"}
                      </div>
                    </div> : <></>
                    }
                    <div style={{marginBottom : "10px"}}>
                    </div>



                    <div
                      className="d-flex"
                      style={{
                        borderTop: "0.5px solid #E2E2E2",
                        borderRadius: "0.5rem",
                        boxShadow: " 0px 4px 20px 0px #25252d1a !important",
                        padding: "8px 0 8px 43px"
                      }}
                    >
                        <button
                        className="Button4"
                          onClick={() => {
                            if (openStatus != d?.vrn) {
                              console.log("nkwerferernrong",openStatus,"rrtyrt",d?.vrn)
                              props?.setSelection("2")
                              setOpenStatus(d?.vrn);
                            }
                          }}>
                          Timeline
                        </button>
                        {
                          d?.currentTripNo ?                         <button
                          className="Button4"
                          style={{
                            margin: "0 0 0 10px",
                            width: "75px"
                          }}
                            onClick={() => {
                              if (openStatus != d?.vrn) {
                                console.log("nkwerferernrong",openStatus,"rrtyrt",d?.vrn)
                                setFrom(d?.currentTripStartTime)
                                props?.setSelection("3")
                                setOpenStatus(d?.vrn);
                              }
                            }}>
                            Trips
                          </button> : <></>
                        }

                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      <div className="nextRow col-12">
        <div className="nextRowCont ">
          <button
            className="PrevButton"
            onClick={addPrevious10Data}
            style={{opacity: (Math.max(0, startIndex)) == "0" ? "0.5" : "1" }}
            disabled = {Math.max(0, startIndex) == "0" ? true : false}
          >
            <SvgImage name="PrevArrow" heigth="12px" width="12px" />
          </button>
          <button
            className="nextButton"
            onClick={addNext10Data}
            style={{
              opacity: (startIndex + 10) >= gpsData?.data?.length ? "0.5" : "1",
            }}
            disabled = {(startIndex + 10) >= gpsData?.data?.length ? true : false}
          >
            <SvgImage name="NextArrow" heigth="12px" width="12px" />
          </button>
        </div>
      </div>
    </div>
  );
}
export default ManageVehicleDetailsCard;
